export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';

export const SIGNUP_RESTAURANT = 'SIGNUP_RESTAURANT';

export const PSEUDO_SIGN_IN = 'PSEUDO_SIGN_IN';

export const SUPER_ADMIN_SIGN_IN_SUCCESS = 'SUPER_ADMIN_SIGN_IN_SUCCESS';

export const PURGE = 'persist/PURGE'; // Action type for redux store persistor purging (purging means clearing)
